/* eslint-disable react/no-array-index-key */
/* eslint-disable comma-dangle */
import React from 'react';
import { Box } from '@mui/material';
import BaseShimmer from './BaseShimmer';
import CardShimmer from './CardShimmer';
import './shimmer.scss';

function SectionShimmer({
  title = true,
  subtitle = true,
  cards = 3,
  gridColumns = 3,
  showCardImages = true,
  showCardButtons = true,
  className = '',
  style = {}
}) {
  const getGridClass = () => {
    switch (gridColumns) {
      case 2:
        return 'shimmer-grid-2';
      case 3:
        return 'shimmer-grid-3';
      case 4:
        return 'shimmer-grid-4';
      default:
        return 'shimmer-grid-3';
    }
  };

  return (
    <Box className={`shimmer-section ${className}`} sx={style}>
      {title && (
        <BaseShimmer
          className="shimmer-section-title"
          height="36px"
          width="50%"
          borderRadius="8px"
        />
      )}

      {subtitle && (
        <BaseShimmer
          className="shimmer-section-subtitle"
          height="18px"
          width="70%"
          borderRadius="6px"
        />
      )}

      {cards > 0 && (
        <Box className={`shimmer-grid ${getGridClass()}`}>
          {Array.from({ length: cards }).map((_, index) => (
            <CardShimmer
              key={index}
              showImage={showCardImages}
              showButton={showCardButtons}
              textLines={3}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

export default SectionShimmer;
